// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3s7IU","location":"Header_location__3CjuJ"};